import { Anchor, ClipboardCheck, MapPin, Snowflake, Truck, type LucideIcon } from "lucide-react";

export interface JourneyStage {
  id: string;
  name: string;
  description: string;
  indicatorLabel: string;
  icon: LucideIcon;
}

export const JOURNEY_STAGES: JourneyStage[] = [
  {
    id: "harbour-catch",
    name: "Harbour Catch",
    description: "The catch comes ashore and is iced within minutes of landing.",
    indicatorLabel: "0 hrs",
    icon: Anchor,
  },
  {
    id: "quality-check",
    name: "Quality Check",
    description: "Sorted, graded, and checked against freshness standards before packing.",
    indicatorLabel: "< 1 hr",
    icon: ClipboardCheck,
  },
  {
    id: "cold-chain-transit",
    name: "Cold-Chain Transit",
    description: "Sealed and moved in temperature-logged coolers, never left at ambient temperature.",
    indicatorLabel: "0–4°C",
    icon: Snowflake,
  },
  {
    id: "hub",
    name: "Hub",
    description: "A brief stop at the nearest ZenFresh hub for final sorting by order.",
    indicatorLabel: "< 2 hrs",
    icon: MapPin,
  },
  {
    id: "last-mile-delivery",
    name: "Last-Mile Delivery",
    description: "Delivered to your door, still cold, the same day it was caught.",
    indicatorLabel: "18 hrs total",
    icon: Truck,
  },
];
